
let language = {

    "PARTNER_VERIFY_URL_PARAM_MISSING": "Url params is missing",
    
    "PARTNER_VERIFY_TOKEN_EXPIRE": "verify token expire.(please check email within {{verifyTime}} minutes)",
    "PARTNER_VERIFY_EMAIL_ALREADY_VERIFY": "the email already verified.",
    
    "PARTNER_VERIFY_SEND_EMAIL_SUCCESS": "Send email successfully",
    
    "PARTNER_VERIFY_PARAM_MISSING": "params is missing"
};

export { language }